const gameStateKeyPrefix = "gameState";
const buildGameStateKey = (puzzleKey = "latest") =>
  `${gameStateKeyPrefix}:${puzzleKey}`;

export const saveGameStateToLocalStorage = (gameState, puzzleKey) => {
  localStorage.setItem(buildGameStateKey(puzzleKey), JSON.stringify(gameState));
};

export const loadGameStateFromLocalStorage = (puzzleKey) => {
  const state = localStorage.getItem(buildGameStateKey(puzzleKey));
  return state ? JSON.parse(state) : null;
};

const gameStatKey = "gameStats";
export const completedPuzzleDaysKey = "completedPuzzleDays";

export const saveStatsToLocalStorage = (gameStats) => {
  localStorage.setItem(gameStatKey, JSON.stringify(gameStats));
};

export const loadStatsFromLocalStorage = () => {
  const stats = localStorage.getItem(gameStatKey);
  return stats ? JSON.parse(stats) : null;
};

export const saveCompletedPuzzleDays = (completedPuzzleDays) => {
  localStorage.setItem(
    completedPuzzleDaysKey,
    JSON.stringify(completedPuzzleDays)
  );
};

export const loadCompletedPuzzleDays = () => {
  try {
    const completedDays = localStorage.getItem(completedPuzzleDaysKey);
    if (!completedDays) {
      return {};
    }
    const parsed = JSON.parse(completedDays);
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
      return {};
    }
    return parsed;
  } catch (error) {
    return {};
  }
};

export const markPuzzleDayCompleted = (puzzleDate) => {
  if (!puzzleDate) {
    return;
  }
  const completedPuzzleDays = loadCompletedPuzzleDays();
  if (completedPuzzleDays[puzzleDate]) {
    return;
  }
  saveCompletedPuzzleDays({
    ...completedPuzzleDays,
    [puzzleDate]: true,
  });
};
